<template>
  <div
    :dir="currentDir"
    class="modal fade va-modal"
    id="user-verification-modal"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered va-dialog">
      <div class="modal-content va-content">
        <!-- Close Button -->
        <button type="button" class="va-close-btn" data-bs-dismiss="modal">
          <i class="fas fa-times"></i>
        </button>

        <!-- Icon Header -->
        <div class="va-icon-header">
          <div class="va-icon-circle">
            <i class="fas fa-user-check"></i>
          </div>
          <div class="va-step-indicator">
            <span :class="{ active: step === 1 }">1</span>
            <span class="va-step-line" :class="{ active: step === 2 }"></span>
            <span :class="{ active: step === 2 }">2</span>
          </div>
        </div>

        <div class="va-body">
          <!-- Title -->
          <h4 class="va-title">
            {{
              step === 1 ? $t("auth.va_title_step1") : $t("auth.va_title_step2")
            }}
          </h4>
          <p class="va-subtitle">
            {{
              step === 1 ? $t("auth.va_intro_step1") : $t("auth.va_intro_step2")
            }}
          </p>

          <!-- Success Message -->
          <div v-if="successMessage" class="va-success-msg">
            <i class="fas fa-check-circle"></i>
            {{ successMessage }}
          </div>

          <!-- Error Message -->
          <div v-if="errorMessage" class="va-error-msg">
            <i class="fas fa-exclamation-circle"></i>
            {{ errorMessage }}
          </div>

          <!-- Step 1: Phone Input -->
          <div v-if="step === 1" class="va-form">
            <div class="va-input-group">
              <label
                ><i class="fas fa-phone"></i>
                {{ $t("auth.va_phone_label") }}</label
              >
              <input id="verifyPhone" type="tel" class="va-input" dir="ltr" />
            </div>

            <button
              class="va-btn va-btn-primary va-btn-full"
              :disabled="isLoading"
              @click="sendPhone"
            >
              <template v-if="isLoading">
                <span class="va-spinner"></span> {{ $t("auth.va_sending") }}
              </template>
              <template v-else>
                <i class="fas fa-paper-plane"></i> {{ $t("auth.va_send_code") }}
              </template>
            </button>
          </div>

          <!-- Step 2: OTP Verification -->
          <div v-else class="va-form">
            <div class="va-input-group">
              <label
                ><i class="fas fa-key"></i> {{ $t("auth.va_otp_label") }}</label
              >
              <input
                v-model="otp"
                type="text"
                class="va-input"
                :placeholder="$t('auth.va_otp_placeholder')"
              />
            </div>

            <div class="va-btn-group">
              <button
                class="va-btn va-btn-secondary"
                :disabled="isLoading"
                @click="goBack"
              >
                <i class="fas fa-arrow-right"></i> {{ $t("common.back") }}
              </button>
              <button
                class="va-btn va-btn-primary"
                :disabled="isLoading"
                @click="verifyOtp"
              >
                <template v-if="isLoading">
                  <span class="va-spinner"></span>
                </template>
                <template v-else>
                  <i class="fas fa-check"></i> {{ $t("auth.va_confirm") }}
                </template>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api";
import i18n from "@/plugins/i18n";
var itiVerify;

export default {
  computed: {
    currentDir() {
      return this.$i18n && this.$i18n.locale === "ar" ? "rtl" : "ltr";
    },
  },
  data() {
    return {
      step: 1,
      otp: "",
      isLoading: false,
      errorMessage: "",
      successMessage: "",
      selectedMethod: "sms", // default
      token: localStorage.getItem("access_token"),
    };
  },
  mounted() {
    const modal = document.getElementById("user-verification-modal");
    const phone = document.getElementById("verifyPhone");

    modal.addEventListener("shown.bs.modal", () => {
      itiVerify = intlTelInput(phone, {
        utilsScript: "assets/js/utils.js",
        initialCountry: "ly",
        separateDialCode: true,
        excludeCountries: ["il"],
        customPlaceholder: function (
          selectedCountryPlaceholder,
          selectedCountryData
        ) {
          // Remove leading 0 from placeholder (e.g., 0922345678 -> 922345678)
          return selectedCountryPlaceholder.replace(/^0/, "");
        },
      });
    });
  },
  methods: {
    goBack() {
      this.errorMessage = "";
      this.successMessage = "";
      this.otp = "";
      this.step = 1;
      this.selectedMethod = "sms";
      this.$nextTick(() => {
        const phone = document.getElementById("verifyPhone");
        itiVerify = intlTelInput(phone, {
          utilsScript: "assets/js/utils.js",
          initialCountry: "ly",
          separateDialCode: true,
          excludeCountries: ["il"],
          customPlaceholder: function (
            selectedCountryPlaceholder,
            selectedCountryData
          ) {
            // Remove leading 0 from placeholder (e.g., 0922345678 -> 922345678)
            return selectedCountryPlaceholder.replace(/^0/, "");
          },
        });
      });
    },

    async sendPhone() {
      this.errorMessage = "";
      this.successMessage = "";
      let Newtoken = localStorage.getItem("access_token");
      //alert(Newtoken);
      try {
        this.isLoading = true;
        const phoneNumber = itiVerify.getNumber();

        const payload = {
          phone: phoneNumber,
          country_code: "+" + itiVerify.getSelectedCountryData().dialCode,
        };

        const res = await fetch(`${apiUrl}/user_verification/send-otp`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${Newtoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(
            errData.message || i18n.global.t("auth.va_send_error")
          );
        }

        this.successMessage = i18n.global.t("auth.va_sent_success");
        this.step = 2;
      } catch (err) {
        this.errorMessage = err.message || i18n.global.t("auth.va_send_error");
      } finally {
        this.isLoading = false;
      }
    },

    async verifyOtp() {
      let Newtoken = localStorage.getItem("access_token");

      this.errorMessage = "";
      if (!this.otp) {
        this.errorMessage = i18n.global.t("auth.va_required_otp");
        return;
      }
      this.isLoading = true;

      try {
        const res = await fetch(`${apiUrl}/user_verification/verify-mobile`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${Newtoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ otp: this.otp }),
        });
        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(
            errData.message || i18n.global.t("auth.va_verify_error")
          );
        }
        Swal.fire(
          i18n.global.t("auth.va_verify_success_title"),
          i18n.global.t("auth.va_verify_success_text"),
          "success"
        );
        this.goBack();
      } catch (err) {
        this.errorMessage =
          err.message || i18n.global.t("auth.va_verify_error");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
/* ========== Animations ========== */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes iconBounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

/* ========== Modal Dialog ========== */
.va-modal .va-dialog {
  max-width: 420px;
}

.va-content {
  border-radius: 24px !important;
  border: none !important;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.15);
  overflow: visible;
  background: #fff;
  animation: fadeIn 0.3s ease;
  position: relative;
  padding: 0 !important;
}

/* ========== Close Button ========== */
.va-close-btn {
  position: absolute;
  top: -12px;
  right: -12px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #fff;
  border: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
}

.va-close-btn i {
  color: #6b7280;
  font-size: 14px;
}

.va-close-btn:hover {
  background: #ef4444;
  transform: rotate(90deg);
}

.va-close-btn:hover i {
  color: #fff;
}

/* ========== Icon Header ========== */
.va-icon-header {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  padding: 30px 20px 25px;
  text-align: center;
  border-radius: 24px 24px 0 0;
  position: relative;
}

.va-icon-circle {
  width: 70px;
  height: 70px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  animation: iconBounce 2s ease-in-out infinite;
}

.va-icon-circle i {
  font-size: 28px;
  color: #00c444;
}

/* Step Indicator */
.va-step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.va-step-indicator span:not(.va-step-line) {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.va-step-indicator span.active {
  background: #fff;
  color: #00c444;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.va-step-line {
  width: 40px !important;
  height: 3px !important;
  background: rgba(255, 255, 255, 0.3) !important;
  border-radius: 2px !important;
}

.va-step-line.active {
  background: #fff !important;
}

/* ========== Body ========== */
.va-body {
  padding: 25px;
}

.va-title {
  text-align: center;
  color: #1f2937;
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 8px;
}

.va-subtitle {
  text-align: center;
  color: #6b7280;
  font-size: 0.9rem;
  margin: 0 0 20px;
  line-height: 1.5;
}

/* ========== Messages ========== */
.va-success-msg,
.va-error-msg {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 16px;
  animation: slideUp 0.3s ease;
}

.va-success-msg {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  color: #047857;
  border: 1px solid #a7f3d0;
}

.va-error-msg {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  color: #dc2626;
  border: 1px solid #fecaca;
}

/* ========== Form ========== */
.va-form {
  animation: slideUp 0.3s ease;
}

.va-input-group {
  margin-bottom: 16px;
}

.va-input-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.va-input-group label i {
  color: #00c444;
  font-size: 0.9rem;
}

.va-input {
  width: 100%;
  height: 48px;
  padding: 0 16px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 15px;
  transition: all 0.3s ease;
  background: #f9fafb;
}

.va-input:focus {
  outline: none;
  border-color: #00c444;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(0, 196, 68, 0.1);
}

/* ========== Buttons ========== */
.va-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 24px;
  border-radius: 12px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.va-btn-primary {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  color: #fff;
  box-shadow: 0 4px 15px rgba(0, 196, 68, 0.3);
}

.va-btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.4);
}

.va-btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.va-btn-secondary {
  background: #f3f4f6;
  color: #374151;
  border: 2px solid #e5e7eb;
}

.va-btn-secondary:hover {
  background: #e5e7eb;
}

.va-btn-full {
  width: 100%;
}

.va-btn-group {
  display: flex;
  gap: 12px;
}

.va-btn-group .va-btn {
  flex: 1;
}

/* Spinner */
.va-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* ========== intl-tel-input ========== */
:deep(.iti) {
  width: 100%;
}

:deep(.iti__selected-flag) {
  border-radius: 10px 0 0 10px;
  padding: 0 10px;
  background: #f3f4f6;
}

/* ========== DARK MODE ========== */
[data-bs-theme="dark"] .va-content,
[data-theme="dark"] .va-content,
.dark .va-content {
  background: #1f2937;
}

[data-bs-theme="dark"] .va-close-btn,
[data-theme="dark"] .va-close-btn,
.dark .va-close-btn {
  background: #374151;
}

[data-bs-theme="dark"] .va-close-btn i,
[data-theme="dark"] .va-close-btn i,
.dark .va-close-btn i {
  color: #9ca3af;
}

[data-bs-theme="dark"] .va-icon-circle,
[data-theme="dark"] .va-icon-circle,
.dark .va-icon-circle {
  background: #374151;
}

[data-bs-theme="dark"] .va-icon-circle i,
[data-theme="dark"] .va-icon-circle i,
.dark .va-icon-circle i {
  color: #00e050;
}

[data-bs-theme="dark"] .va-title,
[data-theme="dark"] .va-title,
.dark .va-title {
  color: #f3f4f6;
}

[data-bs-theme="dark"] .va-subtitle,
[data-theme="dark"] .va-subtitle,
.dark .va-subtitle {
  color: #9ca3af;
}

[data-bs-theme="dark"] .va-input-group label,
[data-theme="dark"] .va-input-group label,
.dark .va-input-group label {
  color: #e5e7eb;
}

[data-bs-theme="dark"] .va-input,
[data-theme="dark"] .va-input,
.dark .va-input {
  background: #374151;
  border-color: #4b5563;
  color: #f3f4f6;
}

[data-bs-theme="dark"] .va-input:focus,
[data-theme="dark"] .va-input:focus,
.dark .va-input:focus {
  background: #374151;
  border-color: #00c444;
}

[data-bs-theme="dark"] .va-btn-secondary,
[data-theme="dark"] .va-btn-secondary,
.dark .va-btn-secondary {
  background: #374151;
  border-color: #4b5563;
  color: #e5e7eb;
}

[data-bs-theme="dark"] :deep(.iti__selected-flag),
[data-theme="dark"] :deep(.iti__selected-flag),
.dark :deep(.iti__selected-flag) {
  background: #374151;
}

/* ========== Responsive ========== */
@media (max-width: 480px) {
  .va-modal .va-dialog {
    max-width: 100%;
    margin: 0.5rem;
  }

  .va-btn-group {
    flex-direction: column;
  }
}
</style>
